<template>
  <div class="r-root-page">
    <div>
      <open-fund-header show-shopping-cart/>
      <div class="r-text-intro">הרשמה</div>
      <router-view/>
    </div>
    <div class="r-footer">
      <support />
      <terms-and-conditions-link-buttons/>
    </div>
  </div>
</template>

<script>
import OpenFundHeader from '@/components/meitav-dash/OpenFundHeader';
import Support from '@/components/Support';
import TermsAndConditionsLinkButtons from '@/components/TermsAndConditionsLinkButtons';

export default {
  name: 'SignupRoot',
  components: { TermsAndConditionsLinkButtons, Support, OpenFundHeader },
};
</script>
